const state = {
  affiliateCampaignModel: null,
  affiliateCampaignPreview: null,
  messageCheckAffiliatesCampaign: null,
  propCheckAffiliatesCampaign: null,
  httpCodeCheckAffiliatesStatus: null,
  campaignModel: null
};

const getters = {
  GetAffiliateCampaignModel: state => {
    return state.registerLoadingStatus;
  },
  GetAffiliateCampaignPreview: state => {
    return state.affiliateCampaignPreview;
  },
  GetHttpCodeCheckAffiliatesStatus: state => {
    let data = {
      status: state.httpCodeCheckAffiliatesStatus,
      message: state.messageCheckAffiliatesCampaign,
      prop: state.propCheckAffiliatesCampaign
    };
    return data;
  },
  GetCampaignModel: state => {
    return state.campaignModel;
  }
};
export { getters, state };

